/**
 * observify
 * @description オブジェクトに購読機能を追加して返却する
 * @param {object} obj 対象のオブジェクト
 * @returns {Proxy}
 */
import { isEqual } from 'lodash';
import Subscriber from '_classes/_Subscriber';

export default function observify(obj: Object): Proxy {
  Object.defineProperty(obj, 'watcher', {
    value: new Subscriber(),
    enumerable: false,
    writable: false,
    configurable: false,
  });

  return new Proxy(obj, {
    set(target: Object, key: string, value: any): boolean {
      if (key in target === false) {
        throw new Error(`存在しないプロパティです：${key}`);
      }

      if (!isEqual(target[key], value)) {
        Object.assign(target, { [key]: value });
        target.watcher.trigger('change');
        target.watcher.trigger(`change:${key}`);
      }

      return true;
    },
  });
}
